import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import GuiaAws from "./GuiaAws";
import { decidir, esSincronizable, idDeToken } from "./usuario/sincro";

// La guia es solo para personas conectadas: aqui se comprueba la sesion CONTRA EL SERVIDOR (no basta con que exista un token) y, de paso, se carga y se
// guarda el progreso de la persona en su cuenta. Sin sesion se muestra un aviso con el enlace para entrar.
// Nota: el contenido de la guia viaja dentro de la aplicacion; este control decide quien la usa y a quien se guarda el progreso, no oculta un secreto.
const API = () => process.env.REACT_APP_URL_API;
const leer = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
const poner = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* sin almacenamiento */ } };
const quitar = (k) => { try { localStorage.removeItem(k); } catch (e) { /* sin almacenamiento */ } };
const claves = () => { const r = []; try { for (let i = 0; i < localStorage.length; i++) { const k = localStorage.key(i); if (esSincronizable(k)) r.push(k); } } catch (e) { /* sin almacenamiento */ } return r; };
const datosLocales = () => { const o = {}; claves().forEach(k => { o[k] = leer(k); }); return o; };

const cabeceras = () => {
    const h = { "Content-Type": "application/json", "front-path": window.location.pathname };
    const t = leer("login_token");
    if (t) { h["x-token"] = t; h.email = leer("login_email") || ""; h.system = String(process.env.REACT_APP_SITE_SYSTEM); }
    if (leer("login_browser")) h["x-browser"] = leer("login_browser");
    if (leer("login_tbkid")) h["x-tbkid"] = leer("login_tbkid");
    return h;
};

// Llama a un endpoint del modulo. Devuelve { ok, fila } o { ok: false, sesion: boolean }
const llamar = async (ruta, param = {}, keepalive = false) => {
    const cuerpo = { param: { system: String(process.env.REACT_APP_SITE_SYSTEM), ...param } };
    const n = leer("nroEmpresaSel"); if (n) cuerpo.param.nroEmpresaSel = n;
    const r = await fetch(`${API()}${ruta}`, { method: "POST", headers: cabeceras(), body: JSON.stringify(cuerpo), keepalive });
    const nuevo = r.headers.get("x-token"); if (nuevo) poner("login_token", nuevo);
    const j = await r.json();
    if (!j.ok) return { ok: false, sesion: !(j.reDirect === "/auth/signin" || /Jwt|Sesi/i.test(String(j.msg))) };
    return { ok: true, fila: (j.rows || [])[0] || {} };
};

const GuiaAcceso = () => {
    const [estado, setEstado] = useState("comprobando");     // comprobando | listo | sinSesion | error
    const [guardado, setGuardado] = useState("ok");           // ok | guardando | pendiente
    const temporizador = useRef(null);
    const enCurso = useRef(false);

    const subir = async (keepalive = false) => {
        if (enCurso.current) return;
        enCurso.current = true; setGuardado("guardando");
        try {
            const r = await llamar("/guiaProgresoGuardar", { datos: datosLocales() }, keepalive);
            if (r.ok) { poner("guiaAws.sync_ts", String(r.fila.actualizado)); quitar("guiaAws.sucio"); setGuardado("ok"); } else setGuardado("pendiente");
        } catch (e) { setGuardado("pendiente"); }
        enCurso.current = false;
    };

    const iniciar = async () => {
        setEstado("comprobando");
        const token = leer("login_token");
        if (!token) { setEstado("sinSesion"); return; }
        try {
            const r = await llamar("/guiaProgresoGet");
            if (!r.ok) { setEstado(r.sesion ? "error" : "sinSesion"); return; }
            const id = idDeToken(leer("login_token") || token);
            const d = decidir({ dueno: leer("guiaAws.dueno") || "", id, local: datosLocales(), remoto: r.fila, sucio: leer("guiaAws.sucio") === "1", tsLocal: leer("guiaAws.sync_ts") });
            claves().forEach(quitar);
            Object.entries(d.local).forEach(([k, v]) => { if (esSincronizable(k)) poner(k, v); });
            poner("guiaAws.dueno", id);
            if (r.fila.actualizado) poner("guiaAws.sync_ts", String(r.fila.actualizado));
            setEstado("listo");
            if (d.subir) { poner("guiaAws.sucio", "1"); subir(); }
        } catch (e) { setEstado("error"); }
    };

    useEffect(() => { iniciar(); }, []);

    // Cada cambio de un dato de la guia se marca y se sube unos segundos despues (tambien al cerrar la pestaña)
    useEffect(() => {
        if (estado !== "listo") return undefined;
        const original = Storage.prototype.setItem, borrar = Storage.prototype.removeItem;
        const marcar = (k) => {
            if (!esSincronizable(k)) return;
            poner("guiaAws.sucio", "1"); setGuardado("pendiente");
            clearTimeout(temporizador.current);
            temporizador.current = setTimeout(() => subir(), 2000);
        };
        Storage.prototype.setItem = function (k, v) { original.call(this, k, v); if (this === window.localStorage) marcar(k); };
        Storage.prototype.removeItem = function (k) { borrar.call(this, k); if (this === window.localStorage) marcar(k); };
        const alCerrar = () => { if (leer("guiaAws.sucio") === "1") subir(true); };
        window.addEventListener("pagehide", alCerrar);
        return () => { Storage.prototype.setItem = original; Storage.prototype.removeItem = borrar; window.removeEventListener("pagehide", alCerrar); clearTimeout(temporizador.current); };
    }, [estado]);

    if (estado === "listo") {
        return (
            <>
                <BrowserRouter><GuiaAws /></BrowserRouter>
                <div role="status" className="badge text-bg-light border no-imprimir" style={{ position: "fixed", right: 10, bottom: 10, zIndex: 2500 }}>
                    <i className={`fa fa-${guardado === "ok" ? "cloud-upload-alt text-success" : guardado === "guardando" ? "sync fa-spin" : "exclamation-triangle text-warning"} me-1`} />
                    {guardado === "ok" ? "Progreso guardado en tu cuenta" : guardado === "guardando" ? "Guardando…" : "Cambios por guardar"}
                </div>
            </>
        );
    }
    return (
        <div className="d-flex align-items-center justify-content-center p-3" style={{ minHeight: "100vh" }}>
            <div className="card" style={{ maxWidth: 480, width: "100%" }}>
                <div className="card-body text-center">
                    <i className="fa fa-graduation-cap fa-3x mb-3 text-primary" />
                    <h4>Guía de servicios AWS</h4>
                    {estado === "comprobando" && <p className="text-muted mb-0"><i className="fa fa-spinner fa-spin me-2" />Comprobando tu sesión…</p>}
                    {estado === "sinSesion" && (<>
                        <p>Esta guía es para personas conectadas: así tu progreso (servicios vistos, favoritos, notas) queda guardado en tu cuenta.</p>
                        <a className="btn btn-primary" href="/auth/signin"><i className="fa fa-sign-in-alt me-2" />Iniciar sesión</a>
                    </>)}
                    {estado === "error" && (<>
                        <p>No pude comprobar tu sesión. Revisa tu conexión e inténtalo otra vez.</p>
                        <button className="btn btn-primary" onClick={iniciar}><i className="fa fa-redo me-2" />Reintentar</button>
                    </>)}
                </div>
            </div>
        </div>
    );
};

export default GuiaAcceso;
